import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const Sidebar = () => {
    const [isOpen, setIsOpen] = useState(true);

    const toggleSidebar = () => setIsOpen(!isOpen);

    return (
        <div className={`fixed top-0 left-0 h-full bg-gray-900 text-white transition-all duration-300 ease-in-out ${isOpen ? 'w-64' : 'w-16'}`}>
            <div className="flex items-center justify-between p-4 border-b border-gray-700">
                <h2 className={`text-xl font-semibold ${!isOpen && 'hidden'}`}>Menu</h2>
                <button onClick={toggleSidebar} className="text-white focus:outline-none">
                    {isOpen ? '❌' : '☰'}
                </button>
            </div>
            <ul className="p-4 space-y-3">
                <li>
                    <Link to="/dashboard" className="block p-2 rounded hover:bg-gray-700">Dashboard</Link>
                </li>
                <li>
                    <Link to="/team" className="block p-2 rounded hover:bg-gray-700">Team</Link>
                </li>
                <li>
                    <Link to="/portfolio" className="block p-2 rounded hover:bg-gray-700">Category</Link>
                </li>
                <li>
                    <Link to="/projects" className="block p-2 rounded hover:bg-gray-700">Projects</Link>
                </li>
                <li>
                    <Link to="/position" className="block p-2 rounded hover:bg-gray-700">Position</Link>
                </li>
                <li>
                    <Link to="/connectus" className="block p-2 rounded hover:bg-gray-700">Connect Us</Link>
                </li>
                <li>
                    <Link to="/get_in_touch" className="block p-2 rounded hover:bg-gray-700">Get In Touch</Link>
                </li>
            </ul>
        </div>
    );
};

export default Sidebar;

